import React from 'react';
import { Box, Button } from '@mui/material';
import { PlayArrow } from '@mui/icons-material';
import { COLORS_ADMIN_PAGE } from '../../../conf/constants';

interface MunicipalityTransferButtonsProps {
  selectedAvailableMunicipalities: number[];
  selectedAssignedMunicipalities: number[];
  onMoveToAssigned: () => void;
  onMoveToAvailable: () => void;
}

const MunicipalityTransferButtons: React.FC<MunicipalityTransferButtonsProps> = ({
  selectedAvailableMunicipalities,
  selectedAssignedMunicipalities,
  onMoveToAssigned,
  onMoveToAvailable
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 1, mx: 0.5, mt: 9 }}>
      <Button
        variant="contained"
        onClick={onMoveToAssigned}
        disabled={selectedAvailableMunicipalities.length === 0}
        sx={{
          minWidth: '40px',
          minHeight: '40px',
          p: '6px',
          bgcolor: COLORS_ADMIN_PAGE.PRIMARY,
          borderRadius: '8px',
          '&:hover': { bgcolor: COLORS_ADMIN_PAGE.PRIMARY },
          '&:disabled': {
            bgcolor: COLORS_ADMIN_PAGE.BORDER,
            color: COLORS_ADMIN_PAGE.TEXT_SECONDARY
          }
        }}
      >
        <PlayArrow sx={{ color: 'white', transform: 'rotate(180deg)' }} />
      </Button>
      <Button
        variant="contained"
        onClick={onMoveToAvailable}
        disabled={selectedAssignedMunicipalities.length === 0}
        sx={{
          minWidth: '40px',
          minHeight: '40px',
          p: '6px',
          bgcolor: COLORS_ADMIN_PAGE.PRIMARY,
          borderRadius: '8px',
          '&:hover': { bgcolor: COLORS_ADMIN_PAGE.PRIMARY },
          '&:disabled': {
            bgcolor: COLORS_ADMIN_PAGE.BORDER,
            color: COLORS_ADMIN_PAGE.TEXT_SECONDARY
          }
        }}
      >
        <PlayArrow sx={{ color: 'white' }} />
      </Button>
    </Box>
  );
};

export default MunicipalityTransferButtons;